export const posts = [
    {
        id: 1,
        title: 'Boost your conversion rate',
        body: 'This is post 1',
        category: 'Lifestyle',
        author: 'Learn with sumit',
        authorImage: "https://avatars.githubusercontent.com/u/73503432?v=4",
        date: 'Jan 1, 2020',
        readTime: '5 min read',
        image: 'https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
    },
    {
        id: 2,
        title: 'Most common use case of redux',
        body: 'Most common use case of redux',
        category: 'Redux',
        author: 'Sohag Raha',
        authorImage: "https://avatars.githubusercontent.com/u/61794606?s=48&v=4",
        date: 'Jan 1, 2020',
        readTime: '5 min read',
        image: "https://images.unsplash.com/photo-1484807352052-23338990c6c6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8d2VifGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    },
    {
        id: 3,
        title: 'Daily Routine of a web developer',
        body: 'This is post 3',
        category: 'Web development',
        author: 'Sohag Raha',
        authorImage: "https://avatars.githubusercontent.com/u/61794606?s=48&v=4",
        date: 'Jun 10, 2020',
        readTime: '15 min read',
        image: 'https://images.unsplash.com/photo-1496171367470-9ed9a91ea931?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80'
    },
    {
        id: 4,
        title: 'Basic Concepts of React',
        body: 'This is post 4',
        category: 'React',
        author: 'Learn with sumit',
        authorImage: "https://avatars.githubusercontent.com/u/73503432?v=4",
        date: 'July 29, 2022',
        readTime: '8 min read',
        image: 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
    },
    {
        id: 5,
        title: 'Javascript, All about it need to know',
        body: 'This is post 3',
        category: 'Javascript',
        author: 'Sohag Raha',
        authorImage: "https://avatars.githubusercontent.com/u/61794606?s=48&v=4",
        date: 'Jan 1, 2020',
        readTime: '12 min read',
        image: "https://images.unsplash.com/photo-1579468118864-1b9ea3c0db4a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8amF2YXNjcmlwdHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
    },
    {
        id: 6,
        title: 'Redux is a predictable state container for JavaScript apps',
        body: 'This is post 23',
        category: 'Redux',
        author: 'Learn with sumit',
        authorImage: "https://avatars.githubusercontent.com/u/73503432?v=4",
        date: 'Nov 20, 2021',
        readTime: '16 min read',
        image: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8amF2YXNjcmlwdHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60',
    },
    {
        id: 7,
        title: 'Regex Cheat Sheet',
        body: 'This is post lorem ipsum',
        category: 'Regex',
        author: 'Anisul Islam',
        authorImage: "https://yt3.ggpht.com/ytc/AMLnZu9qwWLjx8qLFObE0TDxQytCm3kAy02qy3cnv-tWew=s900-c-k-c0x00ffffff-no-rj",
        date: 'Jan 1, 2020',
        readTime: '5 min read',
        image: "https://images.unsplash.com/photo-1487721984358-8ecc6e8b412a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTl8fGphdmFzY3JpcHR8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    },
    {
        id: 8,
        title: 'Most common interview question on react',
        body: 'This is post lorem ipsum',
        category: 'React',
        author: 'Learn with sumit',
        authorImage: "https://avatars.githubusercontent.com/u/73503432?v=4",
        date: 'Jul 13, 2022',
        readTime: '8 min read',
        image: "https://images.unsplash.com/photo-1616587894289-86480e533129?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fGludGVydmlld3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
    },
    {
        id: 9,
        title: 'Redux Essentials : Using Redux Data',
        body: 'This is post lorem ipsum',
        category: 'Redux',
        author: 'Sohag Raha',
        authorImage: "https://avatars.githubusercontent.com/u/61794606?s=48&v=4",
        date: 'DEC 13, 2021',
        readTime: '5 min read',
        image: "https://images.unsplash.com/photo-1529429612779-c8e40ef2f36d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTMwfHxqYXZhc2NyaXB0fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    },
    {
        id: 10,
        title: 'Express.js is a minimal and flexible Node.js framework',
        body: 'This is post lorem ipsum',
        category: 'Express',
        author: 'Anisul Islam',
        authorImage: "https://yt3.ggpht.com/ytc/AMLnZu9qwWLjx8qLFObE0TDxQytCm3kAy02qy3cnv-tWew=s900-c-k-c0x00ffffff-no-rj",
        date: 'Jun 6, 2020',
        readTime: '15 min read',
        image: "https://images.unsplash.com/photo-1487721984358-8ecc6e8b412a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTl8fGphdmFzY3JpcHR8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    },
    {
        id: 11,
        title: 'Why AngulaJS is the best framework for web development',
        body: 'This is post lorem ipsum',
        category: 'AngulaJS',
        author: 'Sohag Raha',
        authorImage: "https://avatars.githubusercontent.com/u/61794606?s=48&v=4",
        date: 'Jun 13, 2020',
        readTime: '15 min read',
        image: "https://images.unsplash.com/photo-1591696331096-c73fe847643d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTUyfHxqYXZhc2NyaXB0fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    },
    {
        id: 12,
        title: 'Manage your code with Git',
        body: 'This is post lorem ipsum',
        category: 'Git',
        author: 'Learn with sumit',
        authorImage: "https://avatars.githubusercontent.com/u/73503432?v=4",
        date: 'Jun 13, 2020',
        readTime: '15 min read',
        image: "https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8Z2l0aHVifGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    }

]
export default posts;